import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-ces-client-landing',
  templateUrl: './identity-mgt-ces-client-landing.component.html',
  styleUrls: ['./identity-mgt-ces-client-landing.component.scss']
})
export class IdentityMgtCesClientLandingComponent implements OnInit {
  public type = '';
  existingUser = '';
  categories: {};
  selection = { name: '' };
  public showAlert: boolean = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute, public forgotService: ForgotService, private appInsightsService: AppInsightsService) {
    this.categories = [
      { cat_id: 1, name: 'I forgot my user ID' },
      { cat_id: 2, name: 'I forgot my password' }
    ];

    this.activatedRoute.queryParams.subscribe(params => {
      this.existingUser = !!params["user"] ? params["user"] : "";
    });

    if(this.existingUser === 'y')
      this.showAlert = true;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.appInsightsService.logEvent("Forgot UI Page - CES Client");
  }

  next() {
    if (this.selection) {
      if (this.selection.name === 'I forgot my password') {
        this.forgotService.setType('pwd');
        this.router.navigate(['/ces/c']);
      }
      if (this.selection.name === 'I forgot my user ID') {
        this.forgotService.setType('userid');
        this.router.navigate(['/ces/c']);
      }
    } else {
      return;
    }
  }
  cancel() {
    this.router.navigate(['/ces']);
  }

}